export default {
  nav: {
    home: 'Home', profile: 'Profile', assistant: 'Assistant',
    tickets: 'Requests', documents: 'Documents', data: 'Privacy', comms: 'Notices',
    uniform: 'Uniform', assets: 'Assets', requests: 'Requests', confirmations: 'Confirmations',
    training: 'Training', absences: 'Absences', approvals: 'Requests to approve',
  },
  abs: {
    title: 'Absences', subtitle: 'Vacation and other absences',
    noProfile: 'Your account is not linked to an employee record yet. Contact HR.',
    loadError: 'Could not load your absences. Try again.',
    balance: 'Vacation balance', balanceYear: 'Vacation balance {year}',
    availableOf: 'days available of {total}',
    entitlement: 'Annual entitlement', used: 'Taken', pendingDays: 'Pending',
    carry: 'Includes {days} carried-over days.', carryExpires: 'They expire on {date}.',
    newRequest: 'New request', kind: 'Type', from: 'From', to: 'To',
    halfStart: 'Half day on the first day', halfEnd: 'Half day on the last day',
    calculating: 'Calculating…', workingDays: '{n} working days', balanceAfter: 'Balance after this request: {n} days',
    endBeforeStart: 'The end date cannot be before the start date.',
    certificate: 'Certificate (optional)',
    certificatePrivacy: 'Only HR can see the certificate. Whoever approves the request cannot see it, or any note.',
    noteOptional: 'Note (optional)',
    sending: 'Sending…', submit: 'Send request',
    previewFailed: 'Could not calculate the days.', submitFailed: 'Could not send the request.',
    created: 'Request sent.', createdCertFailed: 'Request sent, but the certificate was not uploaded. Contact HR to hand it in.',
    history: 'My requests', empty: 'You have not made any requests yet.',
    status: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected', cancelled: 'Cancelled' },
    hrAsked: 'HR asked a question', hrAskedFull: 'HR asked you a question:',
    yourAnswer: 'Your answer', sendAnswer: 'Send answer', answerSent: 'Answer sent.',
    trail: 'Decision trail',
    event: {
      requested: 'Requested', approved: 'Approved', rejected: 'Rejected', acknowledged: 'Acknowledged',
      cancelled: 'Cancelled', comment: 'Comment', hr_question: 'HR question', answer: 'Answer',
    },
    unknownActor: 'System',
    decidedAs: { station_approver: 'Station approver', station_role: 'Station management', hr_fallback: 'HR fallback', admin_own_leave: 'Administrator (own leave of a manager)' },
    cancel: 'Cancel request', cancelConfirm: 'Cancel this request?', keep: 'Keep it', confirmCancel: 'Yes, cancel',
    cancelled: 'Request cancelled.', actionFailed: 'Could not complete the action.',
    daysShort: '{n} days',
  },
  appr: {
    employer: { groundlink_iii: 'Groundlink', ryanair_dac: 'Ryanair DAC' },
    tabInbox: 'Requests', tabEntitlements: 'Yearly leave days',
    title: 'Requests to approve', subtitle: 'Absence requests from your station',
    loadError: 'Could not load the requests. Try again.',
    alreadyDecided: 'Already decided.', actionFailed: 'Could not complete the action.',
    approved: 'Request approved.', rejected: 'Request rejected.', acknowledged: 'Acknowledged.',
    empty: 'Nothing to approve.',
    age: '{n} days ago', overlap: '{n} colleagues already away on these dates', noOverlap: 'No team overlap',
    balanceAfter: 'balance after: {n}',
    rejectReason: 'Reason for rejecting (required)', back: 'Back', confirmReject: 'Reject request',
    acknowledge: 'Acknowledge', reject: 'Reject', approve: 'Approve',
    cannotDecide: 'You cannot decide this request.',
  },
  ent: {
    subtitle: 'Confirm the yearly vacation days for your base',
    loadError: 'Could not load the suggestions. Try again.',
    notApprover: 'Only station approvers can confirm these days.',
    year: 'Year', station: 'Station', allStations: 'All',
    empty: 'No suggestions waiting for confirmation.',
    select: 'Select {name}', suggested: 'Suggested: {n} days', points: '{n} points',
    days: 'Days to confirm', reasonRequired: 'Reason for the change (required)',
    refusedSelf: 'You cannot confirm your own days. Ask another approver or HR.',
    refusedStale: 'The suggestion changed. Reload the list.',
    refusedHr: 'Already confirmed by HR.',
    partial: '{ok} confirmed, {refused} refused.', confirmedN: '{n} confirmed.',
    confirmFailed: 'Could not confirm.', reload: 'Reload',
    confirmSelected: 'Confirm selected ({n})',
  },
  training: {
    title: 'Training', subtitle: 'Your compliance records',
    redirecting: 'Taking you to Training…',
    error: 'Could not open Training. Try again shortly.',
    notLinked: 'Your Training account is not linked yet. Check back soon or contact HR.',
    empty: 'You have no training records yet.',
    openFull: 'Open full Training platform',
    expires: 'Expires',
    status: {
      VALID: 'Valid', WARNING_60: 'Expires in 60 days', WARNING_30: 'Expires in 30 days',
      WARNING_10: 'Expires in 10 days', EXPIRED: 'Expired',
    },
  },
  common: {
    logout: 'Sign out', install: 'Install',
    portalName: 'Employee Portal',
    footer: 'Groundlink III Handling, Lda. · Internal use',
    loading: 'Loading…',
    noRecord: 'No record is linked to your account.',
  },
  login: {
    welcome: 'Welcome', lead: 'Access your HR information.',
    email: 'Email', password: 'Password',
    signIn: 'Sign in', signingIn: 'Signing in…', forgot: 'Forgot your password?',
  },
  forgot: {
    title: 'Forgot your password?',
    lead: 'Enter your email and we’ll send you a link to reset it.',
    email: 'Email', send: 'Send link', sending: 'Sending…', back: 'Back to sign in',
    sentTitle: 'Check your email',
    sentLead: 'If an account exists for {email}, we’ve sent a link to reset your password.',
  },
  setpw: {
    checking: 'Validating invite',
    invalidTitle: 'Invalid or expired link',
    invalidLead: 'This invite is no longer valid. Ask your HR team for a new one.',
    goLogin: 'Go to sign in',
    doneTitle: 'Account activated', doneLead: 'Redirecting to sign in…',
    title: 'Set your password',
    account: 'Account:', chooseLead: 'Choose a password to activate your account.',
    password: 'Password', hint: 'At least 10 characters, with letters and numbers.',
    confirm: 'Confirm password', activate: 'Activate account', activating: 'Activating…',
    errShort: 'Password must be at least 10 characters.',
    errComplexity: 'Password must include letters and numbers.',
    errMatch: 'Passwords do not match.',
    errGeneric: 'Could not set the password.',
  },
  home: {
    morning: 'Good morning', afternoon: 'Good afternoon', evening: 'Good evening', fallbackName: 'Colleague',
    profileTitle: 'My profile', profileDesc: 'Personal and contract details',
    docsTitle: 'My documents', docsDesc: 'Payslips, contracts, certificates',
    gdprTitle: 'Privacy (GDPR)', gdprDesc: 'Requests about your data',
  },
  documents: {
    title: 'My documents', subtitle: 'Payslips, contracts and certificates',
    empty: 'You have no documents available yet.', download: 'Download',
    types: { payslip: 'Payslip', contract: 'Contract', certificate: 'Certificate', circular: 'Circular', medical_certificate: 'Medical certificate', absence_justification: 'Absence justification' },
  },
  privacy: {
    title: 'Privacy & data (GDPR)', subtitle: 'Your rights over your personal data',
    banner: 'Groundlink III Handling processes your data in line with the GDPR. For Ryanair DAC employees, some requests may be routed to Ryanair as data controller.',
    soon: 'Submitting requests directly in the portal — coming soon.',
    soonNote: 'For now, please contact the HR department.',
    rights: [
      ['Access', 'View the data Groundlink III holds about you.'],
      ['Rectification', 'Request correction of inaccurate or outdated data.'],
      ['Erasure', 'Request deletion of your data, within legal retention limits.'],
      ['Portability', 'Receive a copy of your data in a readable format.'],
    ],
  },
  profile: {
    title: 'My profile', subtitle: 'Your details on record with HR',
    fields: {
      name: 'Name', employeeId: 'Employee no.', email: 'Email', phone: 'Phone',
      station: 'Station', department: 'Department', position: 'Role',
      category: 'Professional category', status: 'Status', startDate: 'Start date',
    },
    editable: {
      phone: 'Phone', phone_secondary: 'Phone (alternative)', phone_home: 'Phone (home)',
      address: 'Address', city: 'City', postal_code: 'Postal code', marital_status: 'Marital status',
      emergency_name: 'Emergency contact — name',
      emergency_relationship: 'Emergency contact — relationship',
      emergency_phone: 'Emergency contact — phone',
    },
    requestTitle: 'Request a data correction',
    requestLead: 'Choose the field, enter the correct value and submit. HR reviews the request before applying it.',
    fieldLabel: 'Field', currentLabel: 'Current value', newLabel: 'New value',
    newPlaceholder: 'Enter the correct value', submit: 'Submit request', submitting: 'Sending…',
    sent: 'Request submitted. HR will review it.',
    errValue: 'Enter the new value.', errSend: 'Could not submit the request.',
    myRequests: 'My requests', hrNote: 'HR note:',
    loadError: 'Could not load your profile.',
    status: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
  },
  tickets: {
    title: 'HR requests', subtitle: 'Your queries and the reply history',
    new: 'New request', newTitle: 'New request',
    empty: 'You have no requests yet. Open a new one above.',
    subject: 'Subject', subjectPlaceholder: 'Request subject',
    message: 'Message', messagePlaceholder: 'Describe your query',
    cancel: 'Cancel', send: 'Submit request', sending: 'Sending…',
    errFill: 'Fill in the subject and the message.', errSend: 'Could not submit the request.',
    back: '← Back to requests', replyPlaceholder: 'Write a reply…',
    me: 'Me', hr: 'HR', loadError: 'Could not load the request.',
    categories: { general: 'General', payroll: 'Payroll', contract: 'Contract', leave: 'Leave', documents: 'Documents', it: 'IT' },
    status: { open: 'Open', answered: 'Answered', closed: 'Closed' },
  },
  comms: {
    title: 'Notices', subtitle: 'Internal HR communications',
    empty: 'No communications at the moment.',
    allEmployers: 'All employers', allStations: 'All stations', unread: 'Unread',
  },
  faq: {
    title: 'Frequently asked questions', subtitle: 'Answers to the most common HR questions',
    searchPlaceholder: 'Search…', search: 'Search',
    empty: 'No results. Try other terms or ask the Assistant.',
  },
  assistant: {
    title: 'Assistant', subtitle: 'Questions about your HR data',
    lead: 'Ask about your profile, documents, contract dates or requests. I only access your data.',
    faqLink: 'See frequently asked questions',
    disclaimer: 'The assistant can make mistakes. To change data, use “Request a correction” in your profile.',
    escalate: 'Send to HR', placeholder: 'Type your question…',
    errUnavailable: 'The assistant is unavailable right now.',
    suggestions: [
      'When does my ID document expire?',
      'What documents do I have available?',
      'What is my contract end date?',
      'What is the status of my correction requests?',
    ],
  },
  logisticsUniform: {
    title: 'My Uniform', subtitle: 'Assigned items and renewal dates',
    empty: 'You have no uniform items assigned yet.',
    confirmReceipt: 'Confirm receipt', confirmed: 'Confirmed', confirming: 'Confirming…',
    requestAdjustment: 'Request extension/shortening', deltaMonths: 'Months (+/-)', reason: 'Reason',
    reasonPlaceholder: 'Why do you need more/less time?', send: 'Send request', sending: 'Sending…',
    cancel: 'Cancel', errFill: 'Fill in the months and reason.', errSend: 'Error sending request.',
    adjustmentStatus: { pending: 'Request pending', approved: 'Request approved', rejected: 'Request rejected' },
    status: { active: 'Active', returned: 'Returned', lost: 'Lost', written_off: 'Written off' },
    errLoad: 'Error loading your uniform. Try again.', retry: 'Retry',
  },
  logisticsAssets: {
    title: 'My Assets', subtitle: 'Equipment under your responsibility',
    empty: 'You have no assets assigned yet.',
    category: { HEADSET: 'Headset', RADIO: 'Radio', PHONE: 'Phone', IT_EQUIPMENT: 'IT equipment', OFFICE: 'Office equipment' },
    errLoad: 'Error loading your assets. Try again.', retry: 'Retry',
  },
  logisticsRequests: {
    title: 'My Material Requests', subtitle: 'Internal requests and their status',
    empty: 'You have no material requests yet.',
    errLoad: 'Error loading requests. Try again.', retry: 'Retry',
    new: 'New request', newTitle: 'New material request',
    urgency: 'Urgency', urgencyLow: 'Low', urgencyNormal: 'Normal', urgencyHigh: 'High',
    justification: 'Justification', justificationPlaceholder: 'Why do you need this material?',
    product: 'Product', quantity: 'Qty.', addLine: '+ Add line',
    selectProduct: 'Select…', cancel: 'Cancel', send: 'Send request', sending: 'Sending…',
    errFill: 'Pick at least one product and quantity.', errSend: 'Error sending request.',
    status: {
      open: 'Open', fulfilled_by_stock: 'Fulfilled', converted_to_po: 'On order',
      rejected: 'Rejected', closed: 'Closed',
    },
    detail: {
      title: 'Request', back: 'My requests',
      attachments: 'Attachments', noAttachments: 'No attachments.',
      upload: 'Upload', errUpload: 'Error uploading attachment.',
      errLoad: 'Error loading the request.', retry: 'Retry',
    },
  },
  logisticsConfirmations: {
    title: 'Delivery Confirmations', subtitle: 'Purchase orders awaiting confirmation at your base',
    empty: 'No pending confirmations.',
    accept: 'Confirm receipt', reject: 'Reject confirmation',
    rejectPrompt: 'Reason for rejection (optional):',
    confirmed: 'Confirmed', rejected: 'Rejected — recorded, resolved manually by someone',
  },
};
